import React, { useState } from 'react';
import { FaSeedling, FaLeaf, FaTree, FaWater, FaFlask, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaMicroscope, FaAppleAlt, FaRecycle, FaBug, FaCheckCircle } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';

const AgricultureEnvironmentPage = () => {
  const [expandedPost, setExpandedPost] = useState(null);
  const [expandedModule, setExpandedModule] = useState(null);
  const [expandedRoadmap, setExpandedRoadmap] = useState(null);

  const posts = [
    {
      id: 'agriculture-officer',
      name: 'Agriculture Officer',
      icon: <FaSeedling />,
      conductedBy: 'State Agriculture Departments, UPSC, State PSCs',
      eligibility: 'B.Sc. Agriculture / B.Sc. (Hons) Agriculture',
      ageLimit: '21-35 years (varies by state)',
      salary: '₹35,000 - ₹80,000/month',
      grade: 'Gazetted Officer / Group B',
      description: 'Responsible for agricultural extension, crop advisory, farmer welfare schemes implementation',
      examPattern: [
        { stage: 'Preliminary Exam', duration: '2 hours', type: 'Objective', subjects: 'General Agriculture, General Studies, Reasoning' },
        { stage: 'Main Exam', duration: '3 hours', type: 'Descriptive', subjects: 'Agriculture Subjects (Agronomy, Soil Science, Horticulture, Plant Protection, Extension)' },
        { stage: 'Interview', duration: '30 mins', type: 'Personality Test', subjects: 'Agriculture Knowledge, Current Affairs, Communication' }
      ],
      keyModules: ['Agronomy', 'Soil Science', 'Plant Breeding & Genetics', 'Agricultural Extension', 'Agricultural Economics', 'Crop Protection'],
      responsibilities: [
        'Agricultural extension and farmer training',
        'Crop advisory services',
        'Implementation of government schemes',
        'Soil testing and fertility management',
        'Pest and disease management advisory',
        'Demonstration and field trials',
        'Farm mechanization promotion',
        'Agricultural credit facilitation',
        'Marketing support to farmers',
        'Data collection and reporting'
      ],
      careerPath: 'Agriculture Officer → Senior Agriculture Officer → Assistant Director → Joint Director → Director of Agriculture → Commissioner of Agriculture',
      internshipOpportunities: [
        'State Agriculture Universities (SAUs)',
        'Krishi Vigyan Kendras (KVKs)',
        'ICAR Research Institutes',
        'State Agriculture Departments',
        'NGOs working in agriculture',
        'Agri-input companies',
        'Seed corporations',
        'Agricultural cooperatives'
      ]
    },
    {
      id: 'horticulture-officer',
      name: 'Horticulture Officer',
      icon: <FaAppleAlt />,
      conductedBy: 'State Horticulture Departments, State PSCs',
      eligibility: 'B.Sc. Horticulture / B.Sc. Agriculture with Horticulture specialization',
      ageLimit: '21-35 years',
      salary: '₹35,000 - ₹75,000/month',
      grade: 'Gazetted Officer / Group B',
      description: 'Manages horticultural development, fruit and vegetable production, floriculture promotion',
      examPattern: [
        { stage: 'Written Exam', duration: '3 hours', type: 'Objective + Descriptive', subjects: 'Pomology, Olericulture, Floriculture, Post-Harvest Technology, General Studies' },
        { stage: 'Interview', duration: '20-30 mins', type: 'Personal Interview', subjects: 'Horticulture Knowledge, Projects, Field Experience' }
      ],
      keyModules: ['Pomology (Fruit Science)', 'Olericulture (Vegetable Science)', 'Floriculture', 'Post-Harvest Technology', 'Nursery Management', 'Protected Cultivation'],
      responsibilities: [
        'Fruit and vegetable production promotion',
        'Nursery establishment and management',
        'High-density plantation schemes',
        'Protected cultivation implementation',
        'Post-harvest management',
        'Value addition and processing promotion',
        'Export horticulture development',
        'Farmer training on modern techniques',
        'Market linkage development',
        'Horticultural survey and planning'
      ],
      careerPath: 'Horticulture Officer → Senior Horticulture Officer → Assistant Director (Horticulture) → Joint Director → Director of Horticulture',
      internshipOpportunities: [
        'State Horticulture Departments',
        'National Horticulture Board',
        'ICAR-Indian Institute of Horticultural Research',
        'Fruit Research Stations',
        'Floriculture farms',
        'Food processing units',
        'Export houses (fruits/vegetables)',
        'Protected cultivation units'
      ]
    },
    {
      id: 'sericulture-officer',
      name: 'Sericulture Officer',
      icon: <FaBug />,
      conductedBy: 'State Sericulture Departments, CSB',
      eligibility: 'B.Sc. Sericulture / B.Sc. Agriculture / B.Sc. Biology',
      ageLimit: '21-35 years',
      salary: '₹30,000 - ₹65,000/month',
      grade: 'Group B',
      description: 'Promotes silk production, silkworm rearing, mulberry cultivation, and silk reeling',
      examPattern: [
        { stage: 'Written Exam', duration: '2.5 hours', type: 'Objective', subjects: 'Sericulture Science, General Studies, General Agriculture' },
        { stage: 'Practical Test', duration: '1 hour', type: 'Practical', subjects: 'Silkworm rearing techniques, Disease identification' },
        { stage: 'Interview', duration: '15-20 mins', type: 'Viva Voce', subjects: 'Sericulture knowledge' }
      ],
      keyModules: ['Mulberry Cultivation', 'Silkworm Rearing', 'Silkworm Diseases', 'Post-Cocoon Technology', 'Silk Reeling', 'Sericulture Economics'],
      responsibilities: [
        'Mulberry plantation promotion',
        'Silkworm rearing training',
        'Disease management in silkworms',
        'Quality cocoon production',
        'Silk reeling unit establishment',
        'Market linkage for cocoons',
        'Sericulture scheme implementation',
        'Farmer capacity building',
        'Research demonstration',
        'Data maintenance and reporting'
      ],
      careerPath: 'Sericulture Officer → Senior Sericulture Officer → Assistant Director → Joint Director → Director of Sericulture',
      internshipOpportunities: [
        'Central Silk Board units',
        'State Sericulture Departments',
        'Silk research stations',
        'Mulberry gardens',
        'Cocoon markets',
        'Silk reeling units',
        'Sericulture training centers',
        'Export promotion councils'
      ]
    },
    {
      id: 'forest-range-officer',
      name: 'Forest Range Officer',
      icon: <FaTree />,
      conductedBy: 'UPSC, State PSCs, State Forest Departments',
      eligibility: 'B.Sc. Forestry / B.Sc. Agriculture / B.Sc. Environmental Science',
      ageLimit: '21-30 years',
      salary: '₹44,900 - ₹1,42,400/month',
      grade: 'Group A / Gazetted',
      description: 'Forest conservation, wildlife protection, afforestation programs, forest resource management',
      examPattern: [
        { stage: 'Preliminary Exam', duration: '2 hours', type: 'Objective', subjects: 'General Studies, Forestry Basics' },
        { stage: 'Main Exam', duration: '3 hours', type: 'Descriptive', subjects: 'Forestry, Silviculture, Wildlife Management, Forest Law, Environmental Science' },
        { stage: 'Physical Test', duration: 'Varies', type: 'Walking/Endurance', subjects: '25 km walk in 4 hours' },
        { stage: 'Interview', duration: '30 mins', type: 'Personality Test', subjects: 'Forest knowledge, field exposure' }
      ],
      keyModules: ['Silviculture', 'Forest Management', 'Wildlife Conservation', 'Forest Law', 'Agroforestry', 'Forest Economics', 'GIS & Remote Sensing'],
      responsibilities: [
        'Forest protection and patrolling',
        'Wildlife conservation',
        'Afforestation program implementation',
        'Fire prevention and control',
        'Anti-poaching operations',
        'Timber management',
        'Joint Forest Management (JFM)',
        'Eco-tourism development',
        'Forest survey and inventory',
        'Encroachment removal'
      ],
      careerPath: 'Range Forest Officer → Divisional Forest Officer (DFO) → Conservator of Forests → Principal Chief Conservator of Forests (PCCF)',
      internshipOpportunities: [
        'State Forest Departments',
        'National Parks and Sanctuaries',
        'Wildlife Institutes',
        'Forest Research Institutes',
        'Botanical Gardens',
        'Van Vigyan Kendras',
        'Social Forestry Divisions',
        'Eco-tourism projects'
      ]
    },
    {
      id: 'environmental-engineer',
      name: 'Environmental Engineer',
      icon: <FaRecycle />,
      conductedBy: 'State Pollution Control Boards, PSUs, PSCs',
      eligibility: 'B.E./B.Tech in Environmental Engineering / Civil Engineering',
      ageLimit: '21-35 years',
      salary: '₹40,000 - ₹90,000/month',
      grade: 'Group B / Technical',
      description: 'Environmental impact assessment, pollution control, waste management, sustainability projects',
      examPattern: [
        { stage: 'Written Exam', duration: '3 hours', type: 'Objective + Technical', subjects: 'Environmental Science, Engineering, Pollution Control, General Studies' },
        { stage: 'Interview', duration: '30 mins', type: 'Technical Interview', subjects: 'Environmental projects, technical knowledge' }
      ],
      keyModules: ['Water Pollution Control', 'Air Pollution Control', 'Solid Waste Management', 'Environmental Impact Assessment', 'Wastewater Treatment', 'Environmental Law'],
      responsibilities: [
        'Environmental impact assessment',
        'Pollution monitoring and control',
        'Waste management planning',
        'Air and water quality analysis',
        'EIA report preparation',
        'Compliance monitoring',
        'Sustainable development projects',
        'Industrial effluent treatment',
        'Green building certification',
        'Environmental audit'
      ],
      careerPath: 'Junior Environmental Engineer → Environmental Engineer → Senior Environmental Engineer → Chief Environmental Engineer → Director (Environment)',
      internshipOpportunities: [
        'State Pollution Control Boards',
        'Central Pollution Control Board',
        'Environmental consulting firms',
        'Industries (ETP units)',
        'Municipal corporations',
        'NGOs (environmental)',
        'Research institutions',
        'Green building projects'
      ]
    }
  ];

  const modules = [
    {
      id: 'soil-science',
      name: 'Soil Science',
      icon: <FaFlask />,
      duration: '150 hours',
      topics: [
        {
          unit: 'Soil Formation and Classification',
          subtopics: ['Soil forming factors', 'Weathering processes', 'Soil profile', 'Soil classification systems (USDA, FAO)', 'Indian soil types', 'Soil surveys']
        },
        {
          unit: 'Soil Physical Properties',
          subtopics: ['Soil texture and structure', 'Soil color', 'Soil density', 'Soil porosity', 'Soil water', 'Soil temperature', 'Soil aeration']
        },
        {
          unit: 'Soil Chemistry',
          subtopics: ['Soil colloids', 'Ion exchange', 'Soil pH and buffers', 'Soil organic matter', 'Soil minerals', 'Nutrient availability', 'Soil salinity and sodicity']
        },
        {
          unit: 'Soil Fertility and Plant Nutrition',
          subtopics: ['Essential plant nutrients', 'Nutrient cycles', 'Fertilizers and manures', 'Integrated nutrient management', 'Soil testing', 'Fertilizer recommendations']
        },
        {
          unit: 'Soil Biology',
          subtopics: ['Soil organisms', 'Microbial activities', 'Nitrogen fixation', 'Decomposition', 'Biological nitrogen fixation', 'Biofertilizers']
        },
        {
          unit: 'Problem Soils and Management',
          subtopics: ['Acid soils', 'Alkaline soils', 'Saline soils', 'Waterlogged soils', 'Eroded soils', 'Reclamation techniques']
        }
      ],
      practicals: ['Soil sampling', 'Texture determination', 'pH measurement', 'Nutrient analysis', 'Water holding capacity'],
      careerRelevance: 'Critical for Agriculture Officer, Horticulture Officer positions'
    },
    {
      id: 'crop-production',
      name: 'Crop Production (Agronomy)',
      icon: <FaSeedling />,
      duration: '180 hours',
      topics: [
        {
          unit: 'Crop Production Principles',
          subtopics: ['Climatic requirements', 'Soil requirements', 'Crop ecology', 'Crop seasons', 'Cropping systems', 'Multiple cropping']
        },
        {
          unit: 'Cereal Crops',
          subtopics: ['Rice cultivation', 'Wheat cultivation', 'Maize', 'Millets (Bajra, Jowar)', 'Barley', 'Production technology']
        },
        {
          unit: 'Pulse Crops',
          subtopics: ['Chickpea', 'Pigeon pea', 'Lentil', 'Green gram', 'Black gram', 'Pulse production technology']
        },
        {
          unit: 'Oilseed Crops',
          subtopics: ['Groundnut', 'Soybean', 'Mustard', 'Sunflower', 'Safflower', 'Sesame', 'Oil palm']
        },
        {
          unit: 'Cash Crops',
          subtopics: ['Sugarcane', 'Cotton', 'Jute', 'Tobacco', 'Tea', 'Coffee', 'Rubber']
        },
        {
          unit: 'Weed Management',
          subtopics: ['Weed biology', 'Weed classification', 'Weed control methods', 'Herbicides', 'Integrated weed management']
        },
        {
          unit: 'Crop Rotation and Cropping Systems',
          subtopics: ['Principles of crop rotation', 'Intercropping', 'Mixed cropping', 'Relay cropping', 'Sequential cropping']
        }
      ],
      practicals: ['Field preparation', 'Sowing techniques', 'Fertilizer application', 'Weed identification', 'Crop growth stages'],
      careerRelevance: 'Essential for Agriculture Officer, all agriculture-related positions'
    },
    {
      id: 'irrigation',
      name: 'Irrigation & Water Management',
      icon: <FaWater />,
      duration: '120 hours',
      topics: [
        {
          unit: 'Water Resources',
          subtopics: ['Hydrological cycle', 'Water budgeting', 'Irrigation sources', 'Groundwater', 'Surface water', 'Rainwater harvesting']
        },
        {
          unit: 'Irrigation Methods',
          subtopics: ['Surface irrigation', 'Sprinkler irrigation', 'Drip irrigation', 'Subsurface irrigation', 'Irrigation efficiency', 'Water-saving techniques']
        },
        {
          unit: 'Crop Water Requirements',
          subtopics: ['Evapotranspiration', 'Water consumptive use', 'Irrigation scheduling', 'Critical growth stages', 'Deficit irrigation']
        },
        {
          unit: 'Drainage Engineering',
          subtopics: ['Drainage systems', 'Surface drainage', 'Subsurface drainage', 'Waterlogging', 'Salinity management']
        },
        {
          unit: 'Micro-Irrigation',
          subtopics: ['Drip system design', 'Sprinkler system design', 'Fertigation', 'Maintenance', 'Economics of micro-irrigation']
        },
        {
          unit: 'Command Area Development',
          subtopics: ['Canal systems', 'Water distribution', 'Participatory irrigation management', 'Water user associations']
        }
      ],
      practicals: ['Irrigation scheduling', 'Drip system installation', 'Sprinkler spacing', 'Soil moisture measurement'],
      careerRelevance: 'Important for Agriculture Officer, Horticulture Officer, Environmental Engineer'
    },
    {
      id: 'environmental-studies',
      name: 'Environmental Studies',
      icon: <FaLeaf />,
      duration: '100 hours',
      topics: [
        {
          unit: 'Environmental Basics',
          subtopics: ['Ecosystem', 'Biodiversity', 'Natural resources', 'Environmental pollution', 'Climate change', 'Sustainability']
        },
        {
          unit: 'Air Pollution',
          subtopics: ['Air pollutants', 'Sources of air pollution', 'Effects on health and environment', 'Air quality monitoring', 'Control measures']
        },
        {
          unit: 'Water Pollution',
          subtopics: ['Water pollutants', 'Sources of water pollution', 'Eutrophication', 'Water quality parameters', 'Wastewater treatment']
        },
        {
          unit: 'Soil Pollution',
          subtopics: ['Soil contamination', 'Heavy metals', 'Pesticide residues', 'Industrial waste', 'Soil remediation']
        },
        {
          unit: 'Waste Management',
          subtopics: ['Solid waste management', 'E-waste', 'Biomedical waste', 'Hazardous waste', '3Rs (Reduce, Reuse, Recycle)', 'Composting']
        },
        {
          unit: 'Environmental Laws and Policies',
          subtopics: ['Environmental Protection Act', 'Wildlife Protection Act', 'Forest Conservation Act', 'Water Act', 'Air Act', 'EIA notification']
        },
        {
          unit: 'Climate Change',
          subtopics: ['Global warming', 'Greenhouse gases', 'Carbon footprint', 'Mitigation strategies', 'Adaptation measures', 'International conventions']
        }
      ],
      practicals: ['Water quality testing', 'Air pollution measurement', 'Waste segregation', 'EIA studies'],
      careerRelevance: 'Critical for Environmental Engineer, Forest Range Officer'
    },
    {
      id: 'forestry',
      name: 'Forestry & Wildlife',
      icon: <FaTree />,
      duration: '160 hours',
      topics: [
        {
          unit: 'Silviculture',
          subtopics: ['Forest types of India', 'Silvicultural systems', 'Natural regeneration', 'Artificial regeneration', 'Nursery techniques', 'Plantation forestry']
        },
        {
          unit: 'Forest Management',
          subtopics: ['Forest working plans', 'Forest inventory', 'Sustained yield', 'Forest mensuration', 'Volume estimation', 'Growth and yield']
        },
        {
          unit: 'Agroforestry',
          subtopics: ['Agroforestry systems', 'Social forestry', 'Farm forestry', 'Homestead forestry', 'Tree species selection', 'Economic benefits']
        },
        {
          unit: 'Forest Protection',
          subtopics: ['Forest fires', 'Fire prevention and control', 'Forest pests and diseases', 'Grazing problems', 'Encroachment']
        },
        {
          unit: 'Wildlife Management',
          subtopics: ['Wildlife conservation', 'National parks and sanctuaries', 'Endangered species', 'Wildlife corridors', 'Human-wildlife conflict', 'Ex-situ conservation']
        },
        {
          unit: 'Forest Products',
          subtopics: ['Timber', 'Non-timber forest products (NTFPs)', 'Medicinal plants', 'Minor forest produce', 'Value addition', 'Marketing']
        },
        {
          unit: 'Forest Laws',
          subtopics: ['Indian Forest Act', 'Wildlife Protection Act', 'Forest Rights Act', 'Forest Conservation Act', 'Joint Forest Management']
        }
      ],
      practicals: ['Tree species identification', 'Forest survey', 'Nursery management', 'Wildlife tracking', 'GPS and GIS applications'],
      careerRelevance: 'Essential for Forest Range Officer, Agriculture Officer (agroforestry)'
    },
    {
      id: 'horticulture',
      name: 'Horticulture',
      icon: <FaAppleAlt />,
      duration: '140 hours',
      topics: [
        {
          unit: 'Pomology (Fruit Science)',
          subtopics: ['Fruit classification', 'Tropical fruits (Mango, Banana, Papaya)', 'Subtropical fruits (Citrus, Guava)', 'Temperate fruits (Apple, Pear)', 'Propagation', 'Orchard management']
        },
        {
          unit: 'Olericulture (Vegetable Science)',
          subtopics: ['Vegetable classification', 'Solanaceous vegetables', 'Cucurbits', 'Cole crops', 'Root vegetables', 'Leafy vegetables', 'Season extension']
        },
        {
          unit: 'Floriculture',
          subtopics: ['Commercial flowers', 'Loose flowers', 'Cut flowers', 'Pot plants', 'Landscape gardening', 'Protected cultivation']
        },
        {
          unit: 'Post-Harvest Technology',
          subtopics: ['Harvesting indices', 'Grading and packing', 'Storage', 'Transportation', 'Ripening techniques', 'Value addition', 'Processing']
        },
        {
          unit: 'Protected Cultivation',
          subtopics: ['Greenhouse technology', 'Polyhouse cultivation', 'Shade nets', 'Hydroponics', 'Controlled environment', 'Economics']
        },
        {
          unit: 'Nursery Management',
          subtopics: ['Nursery site selection', 'Propagation techniques', 'Grafting', 'Budding', 'Layering', 'Tissue culture basics']
        }
      ],
      practicals: ['Grafting techniques', 'Vegetable nursery', 'Fruit preservation', 'Flower arrangement', 'Greenhouse management'],
      careerRelevance: 'Critical for Horticulture Officer, Agriculture Officer'
    }
  ];

  const completeRoadmap = {
    preExamPreparation: [
      {
        phase: 'Foundation Phase (Months 1-4)',
        duration: '4 Months',
        focus: 'Core subjects and concept building',
        activities: [
          'Complete B.Sc. level revision of all subjects',
          'NCERT books (Class 11-12) for basics',
          'Standard textbooks for each module',
          'Make comprehensive notes',
          'Understand fundamentals deeply',
          'Start current affairs related to agriculture/environment'
        ],
        outcomes: ['Strong conceptual base', 'Complete syllabus coverage', 'Organized study notes']
      },
      {
        phase: 'Practice Phase (Months 5-7)',
        duration: '3 Months',
        focus: 'Question practice and application',
        activities: [
          'Previous year question papers (last 10 years)',
          'Topic-wise practice questions',
          'State-specific exam papers',
          'Mock tests (sectional)',
          'Practical knowledge application',
          'Current affairs compilation'
        ],
        outcomes: ['Improved speed and accuracy', 'Exam pattern familiarity', 'Time management skills']
      },
      {
        phase: 'Revision Phase (Months 8-9)',
        duration: '2 Months',
        focus: 'Consolidation and weak area improvement',
        activities: [
          'Complete syllabus revision',
          'Formula and concept sheets',
          'Weak area focused study',
          'Full-length mock tests',
          'Agriculture schemes and policies',
          'Recent developments in sector'
        ],
        outcomes: ['Complete syllabus mastery', 'Confidence building', 'Ready for exam']
      },
      {
        phase: 'Final Preparation (Month 10-12)',
        duration: '2-3 Months',
        focus: 'Mock tests and interview prep',
        activities: [
          'Daily full-length mock tests',
          'Answer writing practice (Mains)',
          'Current affairs intensive revision',
          'Interview preparation',
          'Group discussions (if applicable)',
          'Personality development'
        ],
        outcomes: ['Exam-ready confidence', 'Time management perfection', 'Interview readiness']
      }
    ],
    internshipRoadmap: [
      {
        phase: 'During B.Sc. (Year 3-4)',
        duration: '6-12 months',
        opportunities: [
          'Summer internships at KVKs',
          'Field visits to progressive farms',
          'Participation in agricultural exhibitions',
          'Volunteer at extension programs',
          'Student projects at research stations',
          'Industry visits (seed companies, fertilizer units)'
        ],
        skills: ['Practical exposure', 'Farmer interaction', 'Field techniques', 'Extension methods']
      },
      {
        phase: 'After Graduation (Before Exam)',
        duration: '3-6 months',
        opportunities: [
          'Full-time internship at State Agriculture Department',
          'NGOs working in rural development',
          'Agri-input companies (field trials)',
          'Research projects at ICAR institutes',
          'Forest departments (for forestry aspirants)',
          'Environmental consulting firms'
        ],
        skills: ['Professional work experience', 'Government office procedures', 'Report writing', 'Project management']
      },
      {
        phase: 'Post-Selection Training',
        duration: '6-12 months',
        opportunities: [
          'Induction training at training academies',
          'Specialized training programs',
          'Attachment with senior officers',
          'Field postings under supervision',
          'Exposure to different crops/regions',
          'Administrative training'
        ],
        skills: ['Administrative skills', 'Leadership', 'Decision making', 'Policy implementation']
      }
    ],
    fieldExposure: [
      {
        activity: 'Krishi Vigyan Kendra (KVK) Visit',
        duration: '1-2 months',
        learning: ['Farmer training methods', 'Demonstration techniques', 'Farm machinery', 'Soil testing lab operations'],
        when: 'During B.Sc. or after'
      },
      {
        activity: 'Research Station Internship',
        duration: '2-3 months',
        learning: ['Field trials', 'Data collection', 'Research methodology', 'Crop evaluation'],
        when: 'Final year or after graduation'
      },
      {
        activity: 'Progressive Farmer Attachment',
        duration: '15-30 days',
        learning: ['Modern farming practices', 'Farm management', 'Marketing strategies', 'Problem-solving'],
        when: 'Multiple times throughout preparation'
      },
      {
        activity: 'Government Scheme Implementation',
        duration: '1-2 months',
        learning: ['Scheme guidelines', 'Beneficiary selection', 'Documentation', 'Monitoring'],
        when: 'After graduation'
      }
    ]
  };

  const benefits = [
    'Direct involvement in nation building',
    'Work in rural areas with farmers',
    'Excellent salary and benefits',
    'Job security and stability',
    'Gazetted officer status (for officers)',
    'Government quarters/HRA',
    'Medical facilities for family',
    'Pension benefits',
    'Transfer within state',
    'Promotion opportunities',
    'Respect in rural community',
    'Make real impact on agriculture',
    'Field work and office work balance',
    'Continuous learning opportunities',
    'Government schemes implementation',
    'Research and extension opportunities'
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'Complete Study Material',
      description: 'Comprehensive notes covering all modules with diagrams and illustrations'
    },
    {
      icon: <FaMicroscope />,
      title: 'Practical Training',
      description: 'Hands-on training in labs and fields for real-world exposure'
    },
    {
      icon: <FaLaptop />,
      title: 'Online Test Series',
      description: 'State-specific and national level mock tests with detailed solutions'
    },
    {
      icon: <FaSeedling />,
      title: 'Field Visits',
      description: 'Regular farm visits, KVK tours, and exposure to agricultural operations'
    },
    {
      icon: <FaClock />,
      title: 'Current Affairs',
      description: 'Weekly updates on agriculture policies, schemes, and developments'
    },
    {
      icon: <FaTrophy />,
      title: 'Interview Guidance',
      description: 'Mock interviews and personality development for mains and interview'
    }
  ];

  const togglePost = (id) => {
    setExpandedPost(expandedPost === id ? null : id);
  };

  const toggleModule = (id) => {
    setExpandedModule(expandedModule === id ? null : id);
  };

  const toggleRoadmap = (phase) => {
    setExpandedRoadmap(expandedRoadmap === phase ? null : phase);
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      {/* Hero Section */}
      <section style={{ background: 'linear-gradient(135deg, #2d9d36 0%, #43a047 100%)', color: 'white' }} className="py-5 my-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-10 mx-auto text-center">
              <h1 className="display-4 fw-bold mb-4">Agriculture & Environment Sector</h1>
              <p className="lead mb-4">
                Comprehensive training for Agriculture Officer, Horticulture Officer, Sericulture Officer, Forest Range Officer, and Environmental Engineer. Build your career in sustainable development with complete syllabus coverage, practical training, and internship guidance.
              </p>
              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <button className="btn btn-light btn-lg px-5">Start Learning</button>
                <button className="btn btn-outline-light btn-lg px-5">Download Syllabus</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2 className="text-center fw-bold mb-5">What We Offer</h2>
          <div className="row g-4">
            {features.map((feature, idx) => (
              <div key={idx} className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm hover-shadow">
                  <div className="card-body text-center p-4">
                    <div style={{ fontSize: '3rem', color: '#2d9d36' }} className="mb-3">
                      {feature.icon}
                    </div>
                    <h5 className="card-title fw-bold mb-3">{feature.title}</h5>
                    <p className="card-text text-muted">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Government Posts Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center fw-bold mb-2">Government Posts Covered</h2>
          <p className="text-center text-muted mb-5">Comprehensive preparation for all major agriculture and environment sector positions</p>
          
          <div className="accordion" id="postsAccordion">
            {posts.map((post, idx) => (
              <div key={post.id} className="accordion-item border rounded mb-3 shadow-sm">
                <h2 className="accordion-header">
                  <button 
                    className={`accordion-button ${expandedPost === post.id ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => togglePost(post.id)}
                    style={{ background: expandedPost === post.id ? '#e8f5e9' : 'white' }}
                  >
                    <div className="d-flex align-items-center w-100">
                      <div style={{ fontSize: '2rem', color: '#2d9d36' }} className="me-3">
                        {post.icon}
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="mb-1 fw-bold">{post.name}</h5>
                        <p className="mb-0 text-muted small">{post.description}</p>
                      </div>
                    </div>
                  </button>
                </h2>
                {expandedPost === post.id && (
                  <div className="accordion-collapse collapse show">
                    <div className="accordion-body bg-light">
                      <div className="row mb-4">
                        <div className="col-md-4 mb-3">
                          <div className="card h-100 border-success">
                            <div className="card-body">
                              <h6 className="text-muted small">Salary</h6>
                              <p className="fw-bold text-success mb-0">{post.salary}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div className="card h-100 border-success">
                            <div className="card-body">
                              <h6 className="text-muted small">Grade</h6>
                              <p className="fw-bold mb-0">{post.grade}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div className="card h-100 border-success">
                            <div className="card-body">
                              <h6 className="text-muted small">Age Limit</h6>
                              <p className="fw-bold mb-0">{post.ageLimit}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-4">
                        <div className="col-md-6 mb-3">
                          <h6 className="fw-bold mb-3"><FaBook className="me-2 text-success" />Eligibility</h6>
                          <p className="text-muted">{post.eligibility}</p>
                          
                          <h6 className="fw-bold mb-3 mt-4"><FaCheckCircle className="me-2 text-success" />Conducted By</h6>
                          <p className="text-muted">{post.conductedBy}</p>
                        </div>
                        <div className="col-md-6 mb-3">
                          <h6 className="fw-bold mb-3">Key Responsibilities</h6>
                          <ul className="list-unstyled">
                            {post.responsibilities.slice(0, 6).map((resp, ridx) => (
                              <li key={ridx} className="mb-2">
                                <FaCheckCircle className="text-success me-2" />
                                <small>{resp}</small>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      <h6 className="fw-bold mb-3">Exam Pattern</h6>
                      <div className="table-responsive mb-4">
                        <table className="table table-bordered table-hover">
                          <thead className="table-success">
                            <tr>
                              <th>Stage</th>
                              <th>Duration</th>
                              <th>Type</th>
                              <th>Subjects</th>
                            </tr>
                          </thead>
                          <tbody>
                            {post.examPattern.map((exam, eidx) => (
                              <tr key={eidx}>
                                <td className="fw-bold">{exam.stage}</td>
                                <td>{exam.duration}</td>
                                <td>{exam.type}</td>
                                <td><small>{exam.subjects}</small></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <h6 className="fw-bold mb-3">Career Path</h6>
                      <div className="alert alert-success mb-4">
                        <small>{post.careerPath}</small>
                      </div>

                      <h6 className="fw-bold mb-3">Key Modules</h6>
                      <div className="d-flex flex-wrap gap-2 mb-4">
                        {post.keyModules.map((module, midx) => (
                          <span key={midx} className="badge bg-success-subtle text-success px-3 py-2">
                            {module}
                          </span>
                        ))}
                      </div>

                      <h6 className="fw-bold mb-3">Internship Opportunities</h6>
                      <div className="row">
                        {post.internshipOpportunities.map((opp, oidx) => (
                          <div key={oidx} className="col-md-6 mb-2">
                            <small>
                              <FaCheckCircle className="text-success me-2" />
                              {opp}
                            </small>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modules Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2 className="text-center fw-bold mb-2">Course Modules</h2>
          <p className="text-center text-muted mb-5">Detailed syllabus coverage for all agriculture and environment subjects</p>
          
          <div className="accordion" id="modulesAccordion">
            {modules.map((module, idx) => (
              <div key={module.id} className="accordion-item border-2 rounded mb-3 shadow-sm">
                <h2 className="accordion-header">
                  <button 
                    className={`accordion-button ${expandedModule === module.id ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => toggleModule(module.id)}
                    style={{ background: expandedModule === module.id ? '#e8f5e9' : 'white' }}
                  >
                    <div className="d-flex align-items-center w-100">
                      <div style={{ fontSize: '2rem', color: '#2d9d36' }} className="me-3">
                        {module.icon}
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="mb-1 fw-bold">{module.name}</h5>
                        <p className="mb-0 text-muted small">Duration: {module.duration} | {module.careerRelevance}</p>
                      </div>
                    </div>
                  </button>
                </h2>
                {expandedModule === module.id && (
                  <div className="accordion-collapse collapse show">
                    <div className="accordion-body bg-light">
                      <h6 className="fw-bold mb-4">Topics Covered</h6>
                      <div className="row g-3">
                        {module.topics.map((topic, tidx) => (
                          <div key={tidx} className="col-12">
                            <div className="card border-0 shadow-sm">
                              <div className="card-body">
                                <h6 className="fw-bold text-success mb-3">{topic.unit}</h6>
                                <div className="d-flex flex-wrap gap-2">
                                  {topic.subtopics.map((subtopic, sidx) => (
                                    <span key={sidx} className="badge bg-light text-dark border px-3 py-2">
                                      {subtopic}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <h6 className="fw-bold mt-4 mb-3">Practical Training</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {module.practicals.map((practical, pidx) => (
                          <span key={pidx} className="badge bg-success px-3 py-2">
                            <FaMicroscope className="me-2" />
                            {practical}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Complete Roadmap Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center fw-bold mb-2">Complete Preparation Roadmap</h2>
          <p className="text-center text-muted mb-5">From exam preparation to successful career - your complete journey</p>

          {/* Pre-Exam Preparation */}
          <h3 className="fw-bold mb-4 text-success">Pre-Exam Preparation Timeline</h3>
          <div className="accordion mb-5" id="prepAccordion">
            {completeRoadmap.preExamPreparation.map((phase, idx) => (
              <div key={idx} className="accordion-item border rounded mb-3 shadow-sm">
                <h2 className="accordion-header">
                  <button 
                    className={`accordion-button ${expandedRoadmap === `prep-${idx}` ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => toggleRoadmap(`prep-${idx}`)}
                  >
                    <div>
                      <h6 className="mb-1 fw-bold">{phase.phase}</h6>
                      <p className="mb-0 text-muted small">Duration: {phase.duration} | Focus: {phase.focus}</p>
                    </div>
                  </button>
                </h2>
                {expandedRoadmap === `prep-${idx}` && (
                  <div className="accordion-collapse collapse show">
                    <div className="accordion-body bg-light">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <h6 className="fw-bold mb-3">Activities</h6>
                          <ul className="list-unstyled">
                            {phase.activities.map((activity, aidx) => (
                              <li key={aidx} className="mb-2">
                                <FaCheckCircle className="text-success me-2" />
                                <small>{activity}</small>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-md-6 mb-3">
                          <h6 className="fw-bold mb-3">Expected Outcomes</h6>
                          <ul className="list-unstyled">
                            {phase.outcomes.map((outcome, oidx) => (
                              <li key={oidx} className="mb-2">
                                <FaTrophy className="text-warning me-2" />
                                <small>{outcome}</small>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Internship Roadmap */}
          <h3 className="fw-bold mb-4 text-success">Internship & Field Exposure Roadmap</h3>
          <div className="accordion mb-5" id="internAccordion">
            {completeRoadmap.internshipRoadmap.map((phase, idx) => (
              <div key={idx} className="accordion-item border rounded mb-3 shadow-sm">
                <h2 className="accordion-header">
                  <button 
                    className={`accordion-button ${expandedRoadmap === `intern-${idx}` ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => toggleRoadmap(`intern-${idx}`)}
                  >
                    <div>
                      <h6 className="mb-1 fw-bold">{phase.phase}</h6>
                      <p className="mb-0 text-muted small">Duration: {phase.duration}</p>
                    </div>
                  </button>
                </h2>
                {expandedRoadmap === `intern-${idx}` && (
                  <div className="accordion-collapse collapse show">
                    <div className="accordion-body bg-light">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <h6 className="fw-bold mb-3">Opportunities</h6>
                          <ul className="list-unstyled">
                            {phase.opportunities.map((opp, oidx) => (
                              <li key={oidx} className="mb-2">
                                <FaSeedling className="text-success me-2" />
                                <small>{opp}</small>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-md-6 mb-3">
                          <h6 className="fw-bold mb-3">Skills Developed</h6>
                          <div className="d-flex flex-wrap gap-2">
                            {phase.skills.map((skill, sidx) => (
                              <span key={sidx} className="badge bg-success-subtle text-success px-3 py-2">
                                {skill}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Field Exposure Activities */}
          <h3 className="fw-bold mb-4 text-success">Recommended Field Exposure Activities</h3>
          <div className="row g-4">
            {completeRoadmap.fieldExposure.map((activity, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex align-items-start mb-3">
                      <FaTree className="text-success me-3" style={{ fontSize: '2rem' }} />
                      <div>
                        <h6 className="fw-bold mb-1">{activity.activity}</h6>
                        <p className="text-muted small mb-0">Duration: {activity.duration} | {activity.when}</p>
                      </div>
                    </div>
                    <h6 className="fw-bold mb-2">Learning Outcomes:</h6>
                    <ul className="list-unstyled">
                      {activity.learning.map((item, lidx) => (
                        <li key={lidx} className="mb-2">
                          <FaCheckCircle className="text-success me-2" style={{ fontSize: '0.8rem' }} />
                          <small>{item}</small>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2 className="text-center fw-bold mb-5">Career Benefits</h2>
          <div className="row g-3">
            {benefits.map((benefit, idx) => (
              <div key={idx} className="col-md-6 col-lg-3">
                <div className="card h-100 border-0 bg-light hover-shadow">
                  <div className="card-body d-flex align-items-center">
                    <FaCheckCircle className="text-success me-3 flex-shrink-0" style={{ fontSize: '1.5rem' }} />
                    <span className="text-dark">{benefit}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-5 text-white" style={{ background: 'linear-gradient(135deg, #2d9d36 0%, #43a047 100%)' }}>
        <div className="container text-center">
          <h2 className="fw-bold mb-4">Ready to Start Your Journey?</h2>
          <p className="lead mb-4">Join thousands of successful candidates in agriculture and environment sector</p>
          <div className="d-flex gap-3 justify-content-center flex-wrap">
            <button className="btn btn-light btn-lg px-5">Enroll Now</button>
            <button className="btn btn-outline-light btn-lg px-5">Contact Us</button>
          </div>
        </div>
      </section>

      <style>{`
        .hover-shadow {
          transition: all 0.3s ease;
        }
        .hover-shadow:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.15) !important;
        }
        .accordion-button:not(.collapsed) {
          color: #2d9d36;
          font-weight: 600;
        }
        .accordion-button:focus {
          box-shadow: none;
          border-color: rgba(45, 157, 54, 0.25);
        }
        .card {
          transition: all 0.3s ease;
        }
        .badge {
          font-weight: 500;
          font-size: 0.85rem;
        }
        .bg-success-subtle {
          background-color: #e8f5e9 !important;
        }
      `}</style>
    </div>
  );
};

export default AgricultureEnvironmentPage;